import React, { useEffect, useState } from 'react';
import {
  Paper,
  Container,
  Typography,
  Divider,
  Grid,
  Card,
  CardContent,
  TextField,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  IconButton,
} from '@material-ui/core';

import { useDispatch, useSelector } from 'react-redux';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Check';
import { getOctaveBandsModels } from '../app/reducer/octaveBandModal.reducer';
import { getHubModels } from '../app/reducer/hubModal.reducer';
import { getBladeModels } from '../app/reducer/bladeModal.reducer';
import { getGADrawingModel } from '../app/reducer/gaDrawingModal.reducer';
import { getAllFansData } from '../app/reducer/fan.reducer';
import { getCountAllFans, getFanCountInProjects } from '../app/api/util';
// import { getProjectVisits } from '../utils/projectVisit';
import { getProjectVisits, recordProjectVisit, ProjectVisit } from '../utils/projectVisit';
import { getDrafts, getProjects, selectFan, updateFanDetails, updateGADetails, updateProjectDetails, updateProjectState } from '../app/reducer/project.reducer';
import { useHistory } from 'react-router-dom';
import FanListIcon from '../assets/images/FanListIcon';
import { Projects } from './users';
import { ProjectsIcon } from '../assets/images/ProjectsIcon';
import { HubIcon } from '../assets/images/HubIcon';
import { BladeIcon } from '../assets/images/BladeIcon';
import { BarChartIcon } from '../assets/images/BarChartIcon';
import { GADRAWING } from '../assets';
import { EngineeringIcon } from '../assets/images/EngineeringIcon';
import axios from 'axios';
interface IRootState {
  auth?: any;
  projects?: any;
  fan?: any;
}

type StatCardProps = {
  title: string;
  value: number;
  subtitle?: string;
  icon?: React.ReactNode;
};
const StatCard: React.FC<StatCardProps> = ({ title, value, subtitle, icon }) => (
  <Card
    elevation={2}
    style={{
      height: "100%",
      borderRadius: 14,
      background: "#fff",
      padding: 10
    }}
  >
    <CardContent style={{ padding: 16 }}>
      
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 10
        }}
      >
        <Typography
          variant="h5"
          style={{
            fontWeight: 700,
            opacity: 0.7
          }}
        >
          {title}
        </Typography>

        {icon && (
          <div
            style={{
              background: "#e6f4ef",
              borderRadius: 10,
              padding: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            {icon}
          </div>
        )}
      </div>

      {/* Value */}
      <Typography
        variant="h3"
        style={{
          fontWeight: 900,
          color: "#4cbb94"
        }}
      >
        {Number.isFinite(value) ? value : 0}
      </Typography>

      {subtitle && (
        <Typography
          variant="body2"
          style={{ opacity: 0.6, marginTop: 6 }}
        >
          {/* {subtitle} */}
        </Typography>
      )}

    </CardContent>
  </Card>
);

type SectionProps = {
  title: string;
  description?: string;
  children: React.ReactNode;
};

const Section: React.FC<SectionProps> = ({ title, description, children }) => (
  <Card elevation={0} style={{ borderRadius: 16, border: '1px solid #e7e9f0' }}>
    <CardContent style={{ padding: 20 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 12,
          flexWrap: 'wrap',
          marginBottom: 14,
        }}
      >
        <Typography variant="h5" style={{ fontWeight: 900 }}>
          {title}
        </Typography>

        {description ? (
          <Typography variant="body2" style={{ fontSize: '18px', opacity: 0.7, fontWeight: 600 }}>
            {description}
          </Typography>
        ) : null}
      </div>

      {children}
    </CardContent>
  </Card>
);

type Todo = {
  _id: string;
  text: string;
  done: boolean;
};


interface HomeProps {
  history: any;
}

type BarChartItem = {
  _id: string,
  usageCount: number;
};

const SimpleBarChart: React.FC<{ data: BarChartItem[] }> = ({ data }) => {
  const maxValue = Math.max(...data.map((d) => d.usageCount), 1);

  return (
    <div >
      {data.map((item) => {
        const widthPercent = (item.usageCount / maxValue) * 100;

        return (
          <div
            key={item._id}
            style={{
              marginBottom: 2,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                // marginBottom: 2,
                fontWeight: 700,
              }}
            >
              <h2>{item._id}</h2>
              <h2>{item.usageCount}</h2>
            </div>

            <div
              style={{
                background: '#e6f4ef',
                borderRadius: 8,
                height: 10,
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  width: `${widthPercent}%`,
                  background: '#4cbb94',
                  height: '100%',
                  borderRadius: 8,
                  transition: 'width 0.5s ease',
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

// const dummyFanUsage = [
//   { label: 'ENC-223 ', value: 18 },
//   { label: 'ENC-112', value: 12 },
//   { label: 'ENC-32', value: 25 },
//   { label: 'ENC-032', value: 9 },
//   { label: 'ENC-0123', value: 15 },
// ];
const sampleProjects = [
  { id: "P1001", name: 'xyz', clientName: "Metro Rail Corp", createdAt: "2026-02-20T10:30:00Z" },
  { id: "P1002", name: 'xyz', clientName: "Emaar Facilities", createdAt: "2026-02-18T14:00:00Z" },
  { id: "P1003", name: 'xyz', clientName: "Airport Authority", createdAt: "2026-02-25T09:10:00Z" },
  { id: "P1004", name: 'xyz', clientName: "DataHub SG", createdAt: "2026-01-15T08:40:00Z" },
];
interface quickaccess {
  label: string;
  items: {
    p: any;
    isDraft: boolean;
    v: ProjectVisit | undefined;
  }[];
}

const Home: React.FC<HomeProps> = () => {
  const [projectsList, setProjectList] = useState<any[]>([]);
  const [draftsList, setDraftsList] = useState<any[]>([]);
  const projectState = useSelector((state: any) => state.project);
  const [quickAccess, setQuickAccess] = useState<quickaccess>({ label: '', items: [] });
  const auth = useSelector((state: IRootState) => state.auth);
  useEffect(() => {
    if (!auth?.user) return;
    console.log(projectState?.projectsList, auth?.user)
    if (auth.user.userType === 4 || auth.user.userType === 3)
      setProjectList(projectState?.projectsList?.filter((e: any) => e.customer_name == auth?.user?.username));
    else
      setProjectList(projectState?.projectsList ?? [])
    if (auth.user.userType === 4 || auth.user.userType === 3)
      setDraftsList(projectState?.draftList?.filter((e: any) => e.customer_name == auth?.user?.username));
    else
      setDraftsList(projectState?.draftList ?? [])
  }, [auth?.user, projectState])

  const [visits, setVisits] = useState<ProjectVisit[]>(() => getProjectVisits());

  useEffect(() => {
    console.log(projectsList, draftsList)
    const res = buildQuickAccess();
    console.log(res);
    setQuickAccess(res);
  }, [projectsList, draftsList, visits]);
  const history = useHistory();
  useEffect(() => {
    // refresh on mount
    setVisits(getProjectVisits());
  }, []);

  const getCreatedTime = (p: any) => {
    const raw = p?.createdAt || p?.created_at || p?.createdOn || 0;
    const t = new Date(raw).getTime();
    return Number.isFinite(t) ? t : 0;
  };

  const openProjectFromHome = (projectDetails: any, state: 'draft' | 'saved') => {
    if (!projectDetails?._id) return;

    if(![4,3].includes(auth.user.userType))
    recordProjectVisit(projectDetails._id, state);
    setVisits(getProjectVisits());  

    dispatch(updateProjectState(state));
    dispatch(updateProjectDetails(projectDetails));
    dispatch(updateFanDetails(projectDetails?.fan_form));

    if (projectDetails?.ga_details) {
      dispatch(updateGADetails(projectDetails.ga_details));
    }
    if (projectDetails?.fan_details) {
      dispatch(selectFan(projectDetails.fan_details));
    }

    history.push('projects/edit');
  };

  const buildQuickAccess = () => {
    const all = [...(draftsList ?? []), ...(projectsList ?? [])];
    console.log(all)
    const byId = new Map<string, any>();
    all.forEach((p) => {
      if (p?._id) byId.set(p._id, p);
    });

    const draftIds = new Set(draftsList?.map((d) => d?._id).filter(Boolean));

    const visitedExisting = visits
      .map((v) => byId.get(v.projectId))
      .filter(Boolean);

    // If visits exist but all became stale, treat as empty.
    const useFallbackOnly = visitedExisting.length === 0;

    const sortedCreated = [...all].sort((a, b) => getCreatedTime(b) - getCreatedTime(a));
    console.log(sortedCreated)
    const picked: any[] = [];
    const pickedIds = new Set<string>();

    if (!useFallbackOnly) {
      for (const p of visitedExisting) {
        if (picked.length >= 3) break;
        if (!p?._id || pickedIds.has(p._id)) continue;
        picked.push(p);
        pickedIds.add(p._id);
      }
    }

    if (picked.length === 0) {
      // requirement: if empty → last 4 created
      for (const p of sortedCreated) {
        if (picked.length >= 3) break;
        if (!p?._id || pickedIds.has(p._id)) continue;
        picked.push(p);
        pickedIds.add(p._id);
      }
    }

    const label = picked.length > 0 && !useFallbackOnly && visits.length > 0 ? 'Recently visited' : 'Recently created';

    const withMeta = picked.map((p) => {
      const isDraft = draftIds.has(p._id);
      const v = visits.find((x) => x.projectId === p._id);
      return { p, isDraft, v };
    });
    console.log({ label, items: withMeta })
    return { label, items: withMeta };
  };
const TodoList: React.FC = () => {
  let baseUrl = process.env.REACT_APP_API_URL;
  const [todos, setTodos] = useState<Todo[]>([]);
  const [text, setText] = useState("");

  const [editingId, setEditingId] = useState<string | null>(null);
  const [editText, setEditText] = useState("");

  const API = `${baseUrl}/api/user/todos`;

  // Load todos
  useEffect(() => {
    loadTodos();
  }, []);

  const loadTodos = async () => {
    const res = await axios.get(API,{
    params: { userID:auth?.user?.userID}
  });
    setTodos(res.data.data);
  };

  // Add todo
  const addTodo = async () => {
    const trimmed = text.trim();
    if (!trimmed) return;

    const res = await axios.post(API, { text: trimmed,userID:auth?.user?.userID });

    setTodos((prev) => [res.data.data, ...prev]);
    setText("");
  };

  // Toggle todo
  const toggleTodo = async (todo: Todo) => {
    const res = await axios.put(`${API}/${todo._id}`, {
      userID:auth?.user?.userID,
      text: todo.text,
      done: !todo.done,
    });

    setTodos((prev) =>
      prev.map((t) => (t._id === todo._id ? res.data.data : t))
    );
  };

  // Delete todo
  const removeTodo = async (id: string) => {
    await axios.delete(`${API}/${id}`,{params:{userID:auth?.user?.userID}});

    setTodos((prev) => prev.filter((t) => t._id !== id));
  };

  // Start editing
  const startEdit = (todo: Todo) => {
    setEditingId(todo._id);
    setEditText(todo.text);
  };

  // Save edit
  const saveEdit = async (id: string) => {
    const trimmed = editText.trim();
    if (!trimmed) return;

    const res = await axios.put(`${API}/${id}`, {
      userID:auth?.user?.userID,
      text: trimmed,
      done: false,
    });

    setTodos((prev) =>
      prev.map((t) => (t._id === id ? res.data.data : t))
    );

    setEditingId(null);
    setEditText("");
  };

  const remaining = todos?.filter((t) => !t.done).length;

  return (
    <div>
      {/* Add task */}
      <div
        style={{
          display: "flex",
          gap: 12,
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <TextField
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") addTodo();
          }}
          placeholder="Add a task"
          variant="outlined"
          size="medium"
          style={{ width: "80%" }}
        />

        <button
          onClick={addTodo}
          style={{
            padding: "10px 14px",
            borderRadius: 10,
            border: "1px solid #d9dce7",
            fontWeight: 500,
            fontSize: "18px",
            cursor: "pointer",
            backgroundColor: "#4cbb94",
            width: "10%",
            color: "white",
          }}
        >
          ADD
        </button>
      </div>

      {/* Remaining count */}
      <Typography
        variant="body1"
        style={{
          opacity: 0.75,
          fontWeight: 600,
          marginBottom: 8,
        }}
      >
        {remaining} open task{remaining === 1 ? "" : "s"}
      </Typography>

      {/* Todo list */}
      <div
        style={{
          border: "1px solid #eceef5",
          borderRadius: 12,
          overflow: "hidden",
        }}
      >
        <List disablePadding>
          {todos.length === 0 ? (
            <ListItem>
              <ListItemText
                primary={
                  <span style={{ fontSize: "18px" }}>No tasks yet.</span>
                }
                secondary={
                  <span style={{ fontSize: "16px" }}>
                    Add a reminder for your next action.
                  </span>
                }
              />
            </ListItem>
          ) : (
            todos.map((t) => (
              <ListItem
                key={t._id}
                divider
                dense
                style={{
                  background: t.done ? "#73c9ae" : "#ffffff",
                }}
              >
                <Checkbox
                  checked={t.done}
                  onChange={() => toggleTodo(t)}
                  color="primary"
                />

                {editingId === t._id ? (
                  <TextField
                    value={editText}
                    onChange={(e) => setEditText(e.target.value)}
                    size="medium"
                    style={{ flex: 1 }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") saveEdit(t._id);
                    }}
                  />
                ) : (
                  <ListItemText
                    primary={
                      <span
                        style={{
                          fontSize: "18px",
                          opacity: t.done ? 0.55 : 1,
                        }}
                      >
                        {t.text}
                      </span>
                    }
                  />
                )}

                {editingId === t._id ? (
                  <IconButton onClick={() => saveEdit(t._id)}>
                    <SaveIcon style={{ color: "#4cbb94" }} />
                  </IconButton>
                ) : (
                  <IconButton onClick={() => startEdit(t)}>
                    <EditIcon style={{ color: "#4cbb94" }} />
                  </IconButton>
                )}

                <IconButton onClick={() => removeTodo(t._id)}>
                  <DeleteIcon style={{ color: "red" }} />
                </IconButton>
              </ListItem>
            ))
          )}
        </List>
      </div>
    </div>
  );
};

  // const quickAccess = buildQuickAccess();

  let cache = {};
  const dispatch = useDispatch();
  const [count, setCount] = useState({ fanModels: 0, octaveList: 0, bladeList: 0, hubList: 0, gaDrawingList: 0, projectCount: 0, draftCount: 0, userCount: 0 })
  const [fanCountProjects, setFanCountProject] = useState<BarChartItem[]>([])
  const [userProjects, setUserProjects] = useState<Projects[]>([]);
  useEffect(() => {
    let isMounted = true;

    const fetchCountData = async () => {
      try {
        const resp = await getCountAllFans();
        if (!isMounted) return;

        setCount({
          fanModels: resp?.fanCount ?? 0,
          octaveList: resp?.octaveBandCount ?? 0,
          bladeList: resp?.bladeCount ?? 0,
          hubList: resp?.hubCount ?? 0,
          gaDrawingList: resp?.gaDrawingCount ?? 0,
          projectCount: resp?.projectCount ?? 0,
          draftCount: resp?.draftCount ?? 0,
          userCount: resp?.userCount ?? 0,
        });
      } catch (error) {
        console.error('Failed to fetch count data:', error);
      }
    };

    const fetchFanCountInProjects = async () => {
      const resp = await getFanCountInProjects();
      setFanCountProject(resp.slice(0, 4));
    };

    // ✅ load lists for Quick Access
    dispatch(getProjects());
    dispatch(getDrafts());

    fetchCountData();
    fetchFanCountInProjects();
    // console.log(projectsList)
    // setUserProjects(()=>projectsList.filter((e)=>e.customer_name===auth?._id))
    // console.log(projectsList.filter((e)=>e.customer_name===auth?._id));
    return () => {
      isMounted = false;
    };
  }, [dispatch]);
  // Update these selectors to match your store shape.
  const projectsCount = useSelector((state: any) => count?.projectCount);
  const draftsCount = useSelector((state: any) => count?.draftCount);

  const fansCount = useSelector((state: any) => count?.fanModels);
  console.log(fansCount)
  const hubsCount = useSelector((state: any) => count?.hubList);
  const bladesCount = useSelector((state: any) => count?.bladeList);
  const octaveBandsCount = useSelector((state: any) => count?.octaveList);
  const gaDrawingCount = useSelector((state: any) => count?.gaDrawingList);

  console.log(auth?.user?.userType);

  return (
    <div className="page-wrapper">
      <Container maxWidth="xl">
        <Paper className="form-wrapper" style={{ padding: 24, borderRadius: 20 }}>
          <Typography variant="h4" gutterBottom>
            <b>Dashboard</b>
          </Typography>

          <hr />
          <Divider />
          <hr />

          <Grid container spacing={4}>
            {/* SECTION 1: Projects + Drafts */}
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Section title="">
                  <Grid container spacing={6}>
                    {/* LEFT SIDE → Stats */}
                   {![4,3].includes(auth.user.userType)&& <Grid item xs={12} md={3}>
                      <Grid container spacing={5}>
                        <Grid item xs={12}>
                          <StatCard title="Projects" icon={<ProjectsIcon color='#48bc97'/>} value={projectsCount} />
                        </Grid>

                        <Grid item xs={12}>
                          <StatCard title="Drafts" icon={<ProjectsIcon color='#48bc97'/>}  value={draftsCount} />
                        </Grid>
                      </Grid>
                    </Grid>}

                    {/* RIGHT SIDE → Chart + Quick Access */}
                    <Grid item xs={12} md={9}>
                      <Grid container spacing={5}>
                        {/* Bar Chart */}
                       {![4,3].includes(auth.user.userType)&& <Grid item xs={12} md={6}>
                          <Card
                            elevation={2}
                            style={{
                              borderRadius: 14,
                              height: "100%",
                              padding: 16,
                            }}
                          >
                            <Typography variant="h6" style={{ fontWeight: 800, marginBottom: 16 }}>
                              Top 4 Fan model used accross projects
                            </Typography>

                            <SimpleBarChart data={fanCountProjects} />
                          </Card>
                        </Grid>}

                        {/* Quick Access */}
                        <Grid item xs={12} md={6}>
                          <Card
                            elevation={2}
                            style={{
                              borderRadius: 14,
                              height: '100%',
                              padding: 16,
                            }}
                          >
                            <Typography variant="h6" style={{ fontWeight: 800, marginBottom: 6 }}>
                              Quick Project Access
                            </Typography>

                            {/* <Typography variant="body1" style={{ opacity: 0.7, fontWeight: 600, marginBottom: 12 }}>
                              {quickAccess.label}
                            </Typography> */}

                            <div style={{ border: '1px solid #eceef5', borderRadius: 12, overflow: 'hidden' }}>
                              <List disablePadding>
                                {auth?.user?.userType === 1 ? (
                                  <>
                                    {quickAccess.items.length === 0 ? (
                                      <ListItem>
                                        <ListItemText
                                          primary="No projects yet."
                                          secondary="Create a project to see it here."
                                        />
                                      </ListItem>
                                    ) : (
                                      quickAccess.items.map(({ p, isDraft, v }) => {
                                        const title = p?.project || p?.name || 'Untitled project';
                                        const subtitleLeft = p?.customer_name
                                          ? p.customer_name
                                          : (isDraft ? 'Draft' : 'Project');

                                        const subtitleRight = v?.lastVisitedAt
                                          ? `Viewed ${v?.count}x`
                                          : `Created ${new Date(getCreatedTime(p)).toLocaleDateString()}`;

                                        return (
                                          <ListItem
                                            key={p._id}
                                            button
                                            divider
                                            onClick={() =>
                                              openProjectFromHome(p, isDraft ? 'draft' : 'saved')
                                            }
                                          >
                                            <ListItemText
                                              primary={<span style={{fontSize:'20px',fontWeight: 800 }}>{title}</span>}
                                              secondary={
                                                <span style={{ display: 'flex', justifyContent: 'space-between', height:'45px'}}>
                                                  <h2 style={{ fontSize:'15px', opacity: 0.8 }}>{subtitleLeft}</h2>
                                                  <h2 style={{ margin:0, opacity: 0.65, fontWeight: 700 }}>{subtitleRight}</h2>
                                                </span>
                                              }
                                            />
                                          </ListItem>
                                        );
                                      })
                                    )}
                                  </>
                                ) : auth?.user?.userType === 4 ? (
                                  <>
                                    {quickAccess.items.length === 0 ? (
                                      <ListItem>
                                        <ListItemText
                                          primary="Projects not found"
                                          secondary="Ask the admin to create the project"
                                        />
                                      </ListItem>
                                    ) : (
                                      quickAccess.items.map(({ p, isDraft }) => {
                                        const title = p?.project || p?.name || 'Untitled project';
                                        const subtitleLeft = p?.customer_name
                                          ? p.customer_name
                                          : (isDraft ? 'Draft' : 'Project');

                                        const subtitleRight = `Created ${new Date(getCreatedTime(p)).toLocaleDateString()}`;

                                        return (
                                          <ListItem
                                            key={p._id}
                                            button
                                            divider
                                            onClick={() =>
                                              openProjectFromHome(p, isDraft ? 'draft' : 'saved')
                                            }
                                          >
                                            <ListItemText
                                              primary={<span style={{ fontWeight: 800 }}>{title}</span>}
                                              secondary={
                                                <span style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                                                  <span style={{ opacity: 0.8 }}>{subtitleLeft}</span>
                                                  <span style={{ opacity: 0.65, fontWeight: 700 }}>{subtitleRight}</span>
                                                </span>
                                              }
                                            />
                                          </ListItem>
                                        );
                                      })
                                    )}
                                  </>
                                ) : null}
                              </List>
                            </div>
                          </Card>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Section>
              </Grid>

              {/* <Grid item xs={12} md={6}>
    <Section title="Clients">
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <StatCard
            title="Active Clients"
            value={projectsCount}
            subtitle="Active items"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <StatCard
            title="Drafts"
            value={draftsCount}
            subtitle="In progress"
          />
        </Grid>
      </Grid>
    </Section>
  </Grid> */}
            </Grid>

            {/* SECTION 2: Library Counts */}
            {![4,3].includes(auth.user.userType)&&<Grid item xs={12} lg={12}>
              <Section title="Uploads" >
                <Grid container spacing={10}>
                  <Grid item xs={12} sm={6} md={2} lg={2}>
                    <StatCard title="Fans" icon={<FanListIcon color='#48bc97' />} value={fansCount} subtitle="Uploaded models" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={2} lg={2}>
                    <StatCard title="Hubs" icon={<HubIcon color='#48bc97'/>} value={hubsCount} subtitle="Hub library" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={2} lg={2}>
                    <StatCard title="Blade Models" icon={<BladeIcon color='#48bc97'/>} value={bladesCount} subtitle="Blade library" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={2} lg={2}>
                    <StatCard title="Octave Bands" icon={<BarChartIcon color='#48bc97'/>} value={octaveBandsCount} subtitle="Noise profiles" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={2} lg={2}>
                    <StatCard title="GA Drawings" icon={<EngineeringIcon color='#48bc97'/>} value={gaDrawingCount} subtitle="Noise profiles" />
                  </Grid>
                </Grid>
              </Section>
            </Grid>}

            {/* TODO LIST */}
            <Grid item xs={12}>
              <Section title="To-Do List" description="Create Tasks and Reminder Notes">
                <TodoList />
              </Section>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </div>
  );
};

export default Home;